import { PAYMENT_BEHAVIOR } from "@/helpers/order/payment/behavior";
import { makePaymentResult } from "../paymentResult";

/**
 * Gift-card processor.
 *
 * The gift-card amount is captured through the gift-voucher modal flow and the
 * resulting tendered amount is charged like cash, so the stored payment carries
 * the "no data" processor_response sentinel (no external gateway response).
 * Gift-card crediting itself is orchestrated by the checkout component.
 */
export const giftCardProcessor = {
  behaviors: [PAYMENT_BEHAVIOR.GIFT_CARD],

  normalize() {
    return makePaymentResult({
      approved: true,
      processorResponse: "no data",
      cardLastFour: null,
    });
  },
};
